module.exports = __webpack_public_path__ + "b15ccce84c1a7bce5d55fdb0ddbc987c.svg";